<template lang="pug">
  nav#site-navigation.main-navigation
    .menu-coptest-menu-container
      .wrapper-toggle-mobile(@click="opened = !opened")
        span.toggle Opciones Coptest
      ul#primary-menu.menu.nav-menu(:class="{opened:opened}")
        li
          a(href="https://www.coptest.es/" target="_blank") Inicio
        li
          a(href="https://www.coptest.es/test-online-oposiciones-policia/" target="_blank") Qué ofrecemos
        li
          a(href="https://www.coptest.es/libro-para-oposiciones-policia/" target="_blank") Libro
        li
          a(href="https://www.coptest.es/convocatorias-oposiciones-policia/" target="_blank") Convocatorias
        li
          a(href="https://www.coptest.es/blog/" target="_blank") Noticias
        li
          a(href="https://www.coptest.es/productos/" target="_blank") Productos
        li
          a(href="https://www.coptest.es/faqs/" target="_blank") FAQS
        li
          a(href="https://www.coptest.es/contacto/" target="_blank") Contacto
        li.app
          a(href="#") APP
</template>

<script type="text/javascript">
import Logo from "@/components/Logo";

export default {
  name: "Topbar",
  components: {
    Logo,
  },
  data() {
    return {
      opened: false,
    };
  },
};
</script>
